import React from 'react';
import { Timeline } from 'react-twitter-widgets'
import Inc from './include.js';
import './result.scss';

class ResultPage extends React.Component {
	guid = null;
	constructor(props){
		super(props);
		if( this.props.getResultKey() ){
			this.props.showLoading(true);
			this.props.ajax("play/get",{key:this.props.getResultKey()},(res)=>{
				this.props.showLoading(false);
				//console.log( res );
				if( res.ok ){
					this.setState({play:res.play});
				} else {
					this.props.setState({mode:'top'});
				}
			});
		}
		this.state = {
			play: this.props.getPlay()
		};
	}
	render () {
		if( !this.state.play ){
			return (null);
		}

		const lv = this.state.play.lv-1;
		let r = Math.round(this.state.play.passenger/2.1);
		if( r>9 ){
			r = 9;
		}
		if( this.state.play.status==="2" ){
			r = 0;
		}
		const classname = "planet rank" + r;
		let score = this.state.play.passenger + (this.state.play.passenger-3) * this.state.play.lv * this.state.play.lv;

		if( this.state.play.status==="9" ){
			r += lv * 6
		} else {
			score = 0;
		}
		if( score<0 ){
			score = 0;
		}

		let text = "";
		let bad_result = "";
		if( score>0 ){
			text = "革命は成功した。その後のマリーとコリーは「国家の"+Inc.RANK_NAMES[r]+"」として知られている。";
		} else {
			text = "革命は失敗した。その後のマリーとコリーのことなんか誰も知らない知りたくもない。";
			if( this.state.play.passenger>0 ){
				bad_result = (this.state.play.passenger+1) + "人目で失敗";
			} else {
				bad_result = "0人";
			}
		}
		const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Fcollie%2F"+this.state.play.result_key+"&text="+encodeURIComponent(text+"#レトロインク");
		const lvclass = "fas fa-fw fa-" + Inc.LV_FIGURES[this.state.play.lv-1];
		return (
			<div id="result">
				{score>0 ? (
				<div className="result">
					<p className="icon"><i className="fas fa-sun"></i></p>
					<p className={classname}>
						<b>Rank: {Inc.RANKS[r]}</b><br/>
						"国家の{Inc.RANK_NAMES[r]}"<br/>
					</p>
					<p className="text">GOOD END</p>
				</div>
				):(
					<div className="result">
					<p className="icon"><i className="fas fa-skull-crossbones"></i></p>
					<p className="planet rank_bad">
						<b>Rank: G</b><br/>
						"抹消された者"<br/>
					</p>
					<p className="text">BAD END</p>
				</div>
				)}
				<div className="params">
					<dl>
						<dd className="wide">{text}</dd>
						<dt>難易度</dt>
						<dd><i className={lvclass}></i>{Inc.LV[this.state.play.lv-1]}</dd>
						<dt>通過人数</dt>
						{score>0 ? (
						<dd>{this.state.play.passenger}人</dd>
						):(
						<dd>{bad_result}</dd>
						)}
						<dt>きみたちの功績</dt>
						<dd>{score}pt</dd>
					</dl>
				</div>

				<div className="tweet">
					<a href={tweet_url} target="_blank" className="tw" rel="noopener noreferrer"><span className="fab fa-twitter"></span>結果をツイート</a>
				</div>
			
				<div className="story">
					<Timeline
						dataSource={{
							sourceType: 'likes',
							screenName: 'retroink_dev'
						}}
						options={{
							username: '局長',
							height: '200'
						}}
					/>
				</div>

				<div className="links">
					retro-ink 2019
				</div>
				<div className="bottom_btns">
					<button
						className="one"
						onClick={()=>this.finish()}
					><i className="fas fa-arrow-down"></i><br/>ニューゲーム</button>
				</div>

			</div>
		)
	}

	separate(num){
		return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	}
	finish (){
		this.props.setState({mode:'top',result_key:null});
	}
}

export default ResultPage;